import { uploadMutations } from 'entities/modules/uploads';
import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { SuggestionComment } from '../types';

export const suggestionCommentMutations = getMutations({
  createSuggestionComment: {
    action: async ({
      files = [],
      ...payload
    }: {
      suggestionId: string;
      text: string;
      files?: File[];
      status?: string;
    }): Promise<SuggestionComment> => {
      const filePayload = await uploadMutations.multiFileUpload.action({
        files,
        prefix: 'feedback',
      });

      return executeApiCall({
        method: 'post',
        path: 'feedback/suggestions/comments',
        payload: {
          ...payload,
          ...filePayload,
        },
      });
    },

    messages: {
      suppressSuccess: true,

      error: (t) => ({
        title: t('could-not-create-comment'),
        description: t('try-again-in-a-few-moments') as string,
        type: 'error',
      }),
    },
  },

  updateSuggestionComment: {
    action: async (payload: {
      suggestionId: string;
      id: string;
      text: string;
    }): Promise<SuggestionComment> => {
      return executeApiCall({
        path: '/feedback/suggestions/comments',
        method: 'put',
        payload,
      });
    },

    messages: {
      suppressSuccess: true,
    },
  },
});
